// /*
//  * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
//  *
//  * SPDX-License-Identifier: Apache-2.0
//  */

import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StateModule } from '@spartacus/core';
import { CommonModule } from '@angular/common';
import { genEffects } from './effects';
import { multiCartMetaReducers, multiCartReducerProvider, multiCartReducerToken } from './reducers';
import { MULTI_CART_FEATURE, MultiCartEffectsService } from '@spartacus/cart/base/core';

@NgModule({
  imports: [
    CommonModule,
    StateModule,
    StoreModule.forFeature(MULTI_CART_FEATURE, multiCartReducerToken, {
      metaReducers: multiCartMetaReducers,
    }),
    EffectsModule.forFeature(genEffects),
  ],
  providers: [
    multiCartReducerProvider,
    MultiCartEffectsService,
  ],
})
export class GenMultiCartStoreModule {}

